import AdminChat from "@/views/admin/Chat/AdminChats.vue";
import GraphsContent from "@/views/admin/Charts/GraphsContent.vue";
import GraphsContentForCustomerService from "@/views/admin/Charts/GraphsContentForCustomerService.vue";
import RequestsStatus from "@/views/admin/Charts/RequestsStatus.vue";
import LatestRequestsChart from "@/views/admin/Charts/LatestRequestsChart.vue";
import RateAverageReport from "@/views/admin/Charts/rateAverageReport.vue";
import AdminSupport from "@/views/admin/Support/AdminSupport.vue";
import AdminAllRequests from "@/views/admin/Requests/AllRequests/AllRequests.vue";
import AdminGeneralRequests from "@/views/admin/Requests/AllRequests/GeneralRequests.vue";
import AdminProcessingRequests from "@/views/admin/Requests/AllRequests/ProcessingRequests.vue";
import CustomerServiceRequests from "@/views/admin/Requests/AllRequests/CustomerServiceRequests.vue";
import DuplicatedCustomersBasket from "@/views/admin/Requests/DuplicatedCustomers/Index.vue";
import CitiesRequestsChart from "@/views/admin/Charts/CitiesRequestsChart.vue";
import RequestCalls from "@/views/admin/Charts/RequestCalls.vue";
import TasksDetailsRequestSection from "@/components/AdminComponent/TasksDetailsRequestSection"
import AdminRecievedRequests from "@/views/admin/Requests/Recieved/RecievedRequests.vue";
import AdminFollowedRequests from "@/views/admin/Requests/FollowedRequests.vue";
import AdminHasPersonalRequests from "@/views/admin/Requests/HasPersonalRequest/AdminHasPersonalRequests.vue";
import AdministrationRequests from "@/views/admin/Requests/AdministrationRequest/AdministrationRequests.vue";
import AdminFundingDurationRequests from "@/views/admin/Requests/AdminFundingDuration/AdminFundingDurationRequests.vue";
import AdminFeaturedRequests from "@/views/admin/Requests/FeaturedBasket/FeaturedRequests.vue";
import AdminLateRequests from "@/views/admin/Requests/AdminLateRequests.vue";
import AdminArchievedRequests from "@/views/admin/Requests/ArchievedRequests.vue";
import AdminPendingRequests from "@/views/admin/Requests/pending/PendingRequests.vue";
import AdminNeedActionNew from "@/views/admin/Requests/MoveToNew/NeedActionNew.vue";
import AdminNeedActiondone from "@/views/admin/Requests/NeedActionDone.vue";
import AdminWatingNewRequests from "@/views/admin/Requests/WatingNew/WatingNewRequests.vue";
import AdminWatingDoneRequests from "@/views/admin/Requests/WatingDoneRequests.vue";
import AdminFreezingRequests from "@/views/admin/Requests/Freezing/FreezingRequests.vue";
import AdminNeedToTurnNew from "@/views/admin/Requests/QualityNew/NeedToTurnNew.vue";
import AdminArchivedInQuality from "@/views/admin/Requests/ArchivedInQuality/archivedInQualityRequests.vue";
import AdminNeedToTurnDone from "@/views/admin/Requests/NeedToTurnDone.vue";
import AgentsVacations from "@/views/admin/vacations/AgentsVacations.vue";
import RequestSetting from "@/views/admin/Settings/RequestSetting.vue";
import RequestDescription from "@/views/admin/Settings/RequestDescription.vue";
import SendFirebaseNotification from "@/views/admin/Settings/SendFirebaseNotification.vue";

import UsersAlerts from "@/views/admin/UsersAlerts/AlertsIndex.vue";
import AlertShow from "@/views/admin/UsersAlerts/AlertShow.vue";
import UsersAnnouncements from "@/views/admin/UsersAnnouncements/AnnouncementsIndex.vue";
import CustomersSettingIndex from "@/views/admin/CustomersNames/CustomersSettingIndex.vue";
import GeneralSettingIndex from "@/views/admin/CustomersNames/GeneralSettingIndex.vue";
import CustomerServiceSettingIndex from "@/views/admin/CustomerService/CustomerServiceSettingIndex.vue";

import DropdownSettingsIndex from "@/views/admin/Settings/DropdownSettingsIndex.vue";
import AnnouncementShow from "@/views/admin/UsersAnnouncements/AnnouncementsShow";

import RequestSourceSetting from "@/views/admin/Settings/RequestSourceSetting.vue";

import RequestsReceivedReport from "@/views/admin/Reports/RequestsReceivedReport/RequestsReceivedReport.vue";
import RequestsReceivedReportDetails from "@/views/admin/Reports/RequestsReceivedReport/DetailedRequestsSourceReport.vue";
import RequestsReceivedWebReport from "@/views/admin/Reports/RequestsReceivedWebReport/RequestsReceivedWebReport.vue";
import TicketTransferReport from "@/views/admin/Reports/TicketTransferReport/TicketTransferReport.vue";

import SheetColumnsConfig from "@/views/admin/SheetColumnsConfig.vue";
import FinanceSupervisorsVacations from "@/views/admin/vacations/FinanceSupervisorsVacations.vue";
import MortgageManagersVacations from "@/views/admin/vacations/MortgageManagersVacations.vue";
import SalesManagerVacations from "@/views/admin/vacations/SalesManagerVacations.vue";
import LatestReport from "@/views/admin/Reports/LatestReport/AdminLatestReport.vue";


import MovedRequestWtihPostiveClassReport from "@/views/admin/Charts/MovedRequestWtihPostiveClassReport.vue";
import RequestResourcesChart from "@/views/admin/Reports/RequestResourcesChart/RequestResourcesChart.vue";
import ReferralChart from "@/views/admin/Reports/ReferralsReport/ReferralChart.vue";
import ReferralChartNew from "@/views/admin/Reports/ReferralsReport/ReferralChartNew.vue";
import ReferralsCrud from "@/views/admin/Charts/ReferralsCrud/ReferralsCrudIndex.vue";
import RequestResourcesForProductsChart from "@/views/admin/Reports/RequestResourcesForProductsChart/RequestResourcesForProductsChart.vue";
import QualitySurvyChart from "@/views/admin/Reports/QualitySurvyChart/QualitySurvyChart.vue";


import MortgageSettings from "@/views/admin/Reports/MortgageSettings/AdminMortgageSettings.vue";
import BasketSetting from "@/views/admin/Reports/BasketsSettings/BasketSetting.vue";
import QuestionAndAnswerSetting from "@/views/admin/Reports/QuestionAndAnswerSettings/QuestionAndAnswerSetting.vue";
import ClassificationSettingsIndex from "@/views/admin/Settings/ClassificationSettings/Index.vue";


import MortgageSettingsClassification from "@/views/admin/Reports/MortgageSettings/AdminMortgageSettingsClassification.vue";
import VacationHistory from "@/views/admin/vacations/VacationHistory.vue";
import SupportDetails from "@/components/Charts/SupportDetails.vue";
import GlobalSearch from '@/views/admin/GlobalSearch'
import ServiceRate from '@/views/admin/ServiceRate/ServiceRate'
// import AgentPercentage from '@/views/admin/Charts/percentageReport'
import DuplicatedCustomers from '@/views/admin/Charts/DuplicatedCustomers/IndexPage.vue'
import AgentPercentage from '@/views/admin/Charts/percentageReportV2.vue'
import AdminReviewsPage from '@/views/admin/Charts/Percentage/RateSection.vue'
import AdminWhatsappMsgPage from '@/views/admin/Charts/Percentage/WhatsappMsgSection.vue'
import AdminCallCenterPage from '@/views/admin/Charts/Percentage/CallCenterSection.vue'
import AdminRecievedPage from '@/views/admin/Charts/Percentage/RecievedSection.vue'
import AdminRequestsStatisticsPage from '@/views/admin/Charts/Percentage/PositiveSection.vue'
import UsersSettings from '@/views/admin/UserSettings/UsersSettings/UsersSettings.vue'
// import TargetSettings from '@/views/admin/UserSettings/UsersSettings/TargetSettings.vue'
import ProductivityContent from "@/views/admin/Charts/ProductivityContent";
import ProductivityContentV3 from "@/views/admin/Charts/ProductivityContentV3";
import ProductivityContentV3CS from "@/views/admin/Charts/ProductivityContentV3CS";
import ProductivityContentForCustomerService from "@/views/admin/Charts/ProductivityContentForCustomerService";
import RequestSourcesContent from "@/views/admin/Charts/RequestSourcesContent";
import ShowNotification from '@/views/admin/UserSettings/UsersSettings/ShowNotification'
import ChatUsers from '@/views/admin/UserSettings/UsersSettings/ChatUsers'
import EditUser from '@/views/admin/UserSettings/UsersSettings/EditUser'
import PersonalInformation from "@/views/admin/UserSettings/UsersSettings/UserProfile/PersonalInformation"
import JopInfo from "@/views/admin/UserSettings/UsersSettings/UserProfile/JopInfo"
import AttachmentsProfile from '@/views/admin/UserSettings/UsersSettings/UserProfile/AttachmentsProfile'
import UserQualification from '@/views/admin/UserSettings/UsersSettings/UserProfile/UserQualification'
import UserBail from '@/views/admin/UserSettings/UsersSettings/UserProfile/UserBail'
import UserIdentity from '@/views/admin/UserSettings/UsersSettings/UserProfile/UserIdentity'
import UserNotes from '@/views/admin/UserSettings/UsersSettings/UserProfile/UserNotes'
import UserHolidays from '@/views/admin/UserSettings/UsersSettings/UserProfile/UserHolidays'
import AdminReceivedTasks from '@/components/Tickets/Admin/AdminRecievedTickets';
import AdminSendedTasks from '@/components/Tickets/Admin/AdminSendedTickets';
import AdminCompletedTasks from '@/components/Tickets/Admin/AdminCompletedTickets';
import MortgageReportContent from "@/views/admin/Charts/MortgageReportContent";
import ClassificationChart from "@/views/admin/Charts/ClassificationChart.vue";
const TicketsDetails = () => import("@/components/AdminComponent/TicketsDetails")
import CheckExistsCustomersByExcel from "@/views/admin/Pages/CheckExistsCustomersByExcel.vue";
import FundingFormSubmissions from "@/views/admin/FundingFormSubmissions/Index.vue";
import QuestionAndAnswer from "@/views/admin/questionAndAnswer/PostData.vue";
import GoogleSheetImport from "@/views/admin/GoogleSheetImport.vue";

import AdminRejectionsReasons from "@/views/admin/RejectionsReasons/AdminRejectionsReasons.vue";

import AdminProductTypes from "@/views/admin/Products/Types.vue";

import AdminRealEstateTypes from "@/views/admin/RealEstateTypes/AdminRealEstateTypes.vue";

import ClientRegisterRequestAgain from "@/views/admin/Reports/ClientRegisterRequestAgainReport/ClientRegisterRequestAgainIndex.vue";


export const adminRoutes = [

    {
        path: "/admin/receivedTasks",
        name: "AdminReceivedTasks",
        component: AdminReceivedTasks,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.014" viewBox="0 0 18 18.014">
              <g id="ticket" transform="translate(-72.188 -72)">
                <path id="Path_2758" data-name="Path 2758" d="M89.062,76.532a.489.489,0,0,0-.622-.059,1.956,1.956,0,0,1-2.711-2.721.5.5,0,0,0-.059-.617l-.563-.563A1.96,1.96,0,0,0,83.723,72h0a1.959,1.959,0,0,0-1.385.573l-9.582,9.611a1.96,1.96,0,0,0,0,2.765l.377.372a.494.494,0,0,0,.656.034,1.941,1.941,0,0,1,2.736,2.731.489.489,0,0,0,.029.661l.695.695a1.961,1.961,0,0,0,2.77,0h0l9.592-9.592a1.961,1.961,0,0,0,0-2.77ZM79.323,88.747a.981.981,0,0,1-1.385,0l-.4-.4a2.916,2.916,0,0,0-4-4l-.083-.083a.981.981,0,0,1,0-1.385l6.523-6.548,5.882,5.882Zm9.592-9.592-2.369,2.369-5.882-5.887,2.359-2.369a.962.962,0,0,1,.69-.289h0a.978.978,0,0,1,.69.284l.3.3a2.939,2.939,0,0,0,3.93,3.93l.279.279a.976.976,0,0,1,0,1.385Z" transform="translate(0)" fill="#ffffff"/>
                <path id="Path_2759" data-name="Path 2759" d="M169.609,216.41l-2.373-2.374a.981.981,0,0,0-1.385,0h0l-2.315,2.315a.981.981,0,0,0,0,1.385l2.374,2.373a.981.981,0,0,0,1.385,0l2.315-2.315a.969.969,0,0,0,.024-1.375C169.629,216.41,169.624,216.4,169.609,216.41Zm-3,3-2.378-2.373,2.315-2.315h0l2.373,2.373Z" transform="translate(-86.606 -134.813)" fill="#ffffff"/>
              </g>
            </svg>
          `,
            listed: true,
            page_name: "التذاكر المستلمة"
        },
    },

    {
        path: "/admin/product-types",
        name: "AdminProductTypes",
        component: AdminProductTypes,
        meta: {
          icon: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>format-list-bulleted-type</title>
                <path d="M5,9.5L7.5,14H2.5L5,9.5M3,4H7V8H3V4M5,20A2,2 0 0,0 7,18A2,2 0 0,0 5,16A2,2 0 0,0 3,18A2,2 0 0,0 5,20M9,5V7H21V5H9M9,19H21V17H9V19M9,13H21V11H9V13Z" fill="#ffffff"/>
            </svg>
          `,
            listed: true,
            page_name: "أنواع المنتجات",
        },
    },
    {
        path: "/admin/rejections-reasons",
        name: "AdminRejectionsReasons",
        component: AdminRejectionsReasons,
        meta: {
            icon: `
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>block-helper</title>
                <path d="M12,0A12,12 0 0,1 24,12A12,12 0 0,1 12,24A12,12 0 0,1 0,12A12,12 0 0,1 12,0M12,2A10,10 0 0,0 2,12C2,14.4 2.85,16.6 4.26,18.33L18.33,4.26C16.6,2.85 14.4,2 12,2M12,22A10,10 0 0,0 22,12C22,9.6 21.15,7.4 19.74,5.67L5.67,19.74C7.4,21.15 9.6,22 12,22Z" fill="#ffffff"/>
           </svg>
          `,
            listed: true,
            page_name: "اسباب الرفض"
        },
    },

    //===============================================================================================
    // انواع العقارات
    //===============================================================================================
    {
        path: "/admin/real-estate-types",
        name: "AdminRealEstateTypes",
        component: AdminRealEstateTypes,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>home-group</title>
                <path d="M17,16H15V22H12V17H8V22H5V16H3L10,10L17,16M6,2L10,6H9V9H7V6H5V9H3V6H2L6,2M18,3L23,8H22V12H19V9H17V12H15.34L14,10.87V8H13L18,3Z" fill="#ffffff"    />
            </svg>
            `,
            listed: true,
            page_name: "انواع العقارات",
        },
    },
    //===============================================================================================

    {
        path: "/admin/question-and-answers",
        name: "AdminQuestionAndAnswer",
        component: QuestionAndAnswer,
        meta: {
            icon: `
       <svg xmlns="http://www.w3.org/2000/svg" width="18.552" height="19" viewBox="0 0 20.552 21">
        <g id="post_icon" transform="translate(1 1)">
            <g id="post">
            <path id="outline" d="M2,3H19.552A2.448,2.448,0,0,1,22,5.448v12.1A2.448,2.448,0,0,1,19.552,20H2.448A2.448,2.448,0,0,1,0,17.552V5.448A2.448,2.448,0,0,1,2.448,3Z" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="line_1" x2="14" transform="translate(3 7)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="line_2" x2="10" transform="translate(3 11)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
        </g>
        </svg>

        `,
            listed: true,
            page_name: "منتدى الوساطة",
        },
    },

    {
        path: "/admin/tickets/sent",
        name: "admin_sent_tickets",
        component: AdminSendedTasks,
        meta: {
            icon: "",
            listed: true,
            group: "التذاكـر",
            page_name: "التذاكر المرسله",
        },
    },

    {
        path: "/admin/tickets/recieved",
        name: "admin_recieved_tickets",
        component: AdminReceivedTasks,
        meta: {
            icon: "",
            listed: true,
            group: "التذاكـر",
            page_name: "التذاكر المستلمه",
        },
    },

    {
        path: "/admin/tickets/completed",
        name: "admin_completed_tickets",
        component: AdminCompletedTasks,
        meta: {
            icon: "",
            listed: true,
            group: "التذاكـر",
            page_name: "التذاكر المكتمله",
        },
    },

    {
        path: "/admin/ticket-details/:ticeket",
        name: "admin_tickets_details",
        component: TasksDetailsRequestSection,
        meta: {
            icon: ``,
            listed: false,
            page_name: "بيانات التذكرة",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/chats",
        name: "admin-chats",
        component: AdminChat,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M8.00033 18.666H18.667V15.9993H8.00033V18.666ZM8.00033 14.666H24.0003V11.9993H8.00033V14.666ZM8.00033 10.666H24.0003V7.99935H8.00033V10.666ZM2.66699 29.3327V5.33268C2.66699 4.59935 2.92833 3.97179 3.45099 3.45002C3.97366 2.92824 4.60121 2.6669 5.33366 2.66602H26.667C27.4003 2.66602 28.0283 2.92735 28.551 3.45002C29.0737 3.97268 29.3345 4.60024 29.3337 5.33268V21.3327C29.3337 22.066 29.0728 22.694 28.551 23.2167C28.0292 23.7393 27.4012 24.0002 26.667 23.9993H8.00033L2.66699 29.3327ZM6.86699 21.3327H26.667V5.33268H5.33366V22.8327L6.86699 21.3327Z" fill="white"/>
            </svg>
        `,
            listed: true,
            page_name: "محادثات العملاء"
        },
    },
    // {
    //     path: "/admin/charts",
    //     name: "admin-charts",
    //     component: GraphsContent,
    //     meta: {
    //         icon: `
    //     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    //       <g id="Analytics_2" data-name="Analytics 2" transform="translate(-1 -1)">
    //         <rect id="Rectangle_1796" data-name="Rectangle 1796" width="18" height="18" rx="1.5" transform="translate(1.5 1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1797" data-name="Rectangle 1797" width="2" height="12" transform="translate(9.5 4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1798" data-name="Rectangle 1798" width="2" height="6" transform="translate(14.5 10.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1799" data-name="Rectangle 1799" width="2" height="9" transform="translate(4.5 7.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //       </g>
    //     </svg>
    //     `,
    //         listed: true,
    //         group: "الرسوم البيانية",
    //         page_name: "الاداء اليومي",
    //         breadcrumb: "",
    //     },
    // },

    {
        path: "/admin/charts/request-sources",
        name: "RequestResourcesChart",
        component: RequestResourcesChart,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "تصنيفات مصادر المعاملات",
        },
    },


    // {
    //     path: "/admin/charts/referrals",
    //     name: "ReferralChart",
    //     component: ReferralChart,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الرسوم البيانية",
    //         page_name: "تقرير الروابط الديناميكية",
    //     },
    // },

    {
        path: "/admin/charts/referrals-new",
        name: "ReferralChartNew",
        component: ReferralChartNew,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "تقرير الروابط الديناميكية الجديد",
        },
    },

    {
        path: "/admin/charts/referrals-crud",
        name: "ReferralsCrud",
        component: ReferralsCrud,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "إدارة الروابط الديناميكية",
        },
    },

    {
        path: "/admin/charts/request-sources-products",
        name: "RequestResourcesForProductsChart",
        component: RequestResourcesForProductsChart,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "منتجات مصادر المعاملات",
        },
    },

    {
        path: "/admin/charts/quality-survy",
        name: "QualitySurvyChart",
        component: QualitySurvyChart,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "نتائج تقييم الجودة",
        },
    },

    {
        path: "/admin/charts/moved-requests-with-positive",
        name: "MovedRequestWtihPostiveClassReport",
        component: MovedRequestWtihPostiveClassReport,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "طلبات (مرفوع ، مكتمل) ",
        },
    },

    // {
    //     path: "/admin/classification",
    //     name: "admin-classification",
    //     component: ClassificationChart,
    //     meta: {
    //         icon: `
    //     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    //       <g id="Analytics_2" data-name="Analytics 2" transform="translate(-1 -1)">
    //         <rect id="Rectangle_1796" data-name="Rectangle 1796" width="18" height="18" rx="1.5" transform="translate(1.5 1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1797" data-name="Rectangle 1797" width="2" height="12" transform="translate(9.5 4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1798" data-name="Rectangle 1798" width="2" height="6" transform="translate(14.5 10.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //         <rect id="Rectangle_1799" data-name="Rectangle 1799" width="2" height="9" transform="translate(4.5 7.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    //       </g>
    //     </svg>
    //     `,
    //         listed: true,
    //         group: "الرسوم البيانية",
    //         page_name: "تصنيفات الطلب - استشاري المبيعات",
    //         breadcrumb: "",
    //     },
    // },

    {
        path: "/admin/general-filter",
        name: "general-filter",
        component: GlobalSearch,
        meta: {
            icon: ``,
            listed: false,
            page_name: "البحث العام",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/tickets-details/:id",
        name: "tickets-details",
        component: TicketsDetails,
        meta: {
            icon: ``,
            listed: false,
            page_name: "التذاكر",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/show-notification/:id",
        name: "show-notification",
        component: ShowNotification,
        meta: {
            icon: ``,
            listed: false,
            page_name: "التنبيهات",
            breadcrumb: "",
        },
    },

   

    {
        path: "/admin/users/edit/:id",
        name: "edit-user",
        component: EditUser,
        meta: {
            icon: ``,
            listed: false,
            page_name: "تعديل",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/chats/:id",
        name: "show-chats",
        component: ChatUsers,
        meta: {
            icon: ``,
            listed: false,
            page_name: "المحادثات",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/vacation_history/:id",
        name: "vacation_history",
        component: VacationHistory,
        meta: { icon: "", listed: false, page_name: "سجل الطلب" },
    },

    {
        path: "/admin/service-rate",
        name: "service-rate",
        component: ServiceRate,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g clip-path="url(#clip0_1047_829)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.323 27.7118C16.6955 31.4054 21.4661 32.5207 26.2361 30.2134L30.2393 31.9999L28.913 28.4191C33.3611 24.375 32.5649 18.8169 29.2905 15.0275C29.0711 16.4841 28.6368 17.8648 28.018 19.1412C27.1386 20.956 25.8799 22.5701 24.3374 23.8983C22.843 25.186 21.0986 26.1956 19.1974 26.8483C17.3855 27.4705 15.4011 27.7813 13.3236 27.7118H13.323ZM13.9749 6.32285L15.3411 9.95117L18.8043 10.3031C18.9586 10.3166 19.0699 10.4698 19.058 10.6458C19.0505 10.7316 19.0186 10.8033 18.963 10.8579L16.3418 13.4546L17.1161 17.3043C17.1518 17.4753 17.0568 17.642 16.9055 17.6824C16.8305 17.7009 16.7511 17.6825 16.6911 17.6378L13.713 15.6178L10.7268 17.647C10.5955 17.7371 10.4249 17.6874 10.3455 17.5384C10.3055 17.4661 10.298 17.3809 10.3136 17.3043L11.088 13.4546L8.46676 10.8579C8.35176 10.7451 8.33988 10.5422 8.43926 10.4116C8.49488 10.3435 8.56614 10.3123 8.63801 10.3073L12.093 9.95613L13.4586 6.32285C13.5186 6.16038 13.6811 6.08801 13.8243 6.15541C13.8955 6.18734 13.9474 6.25048 13.9749 6.32285ZM14.0549 0.00841478L14.0686 0.00912427C17.8236 0.138251 21.1905 1.65301 23.5999 3.99786C26.0499 6.38245 27.5193 9.6248 27.4274 13.1609V13.1687C27.333 16.7105 25.6924 19.8535 23.1168 22.072C20.5824 24.2551 17.1361 25.5429 13.3793 25.4173C12.3274 25.3825 11.3105 25.2399 10.3424 25.0036C9.43301 24.7809 8.55989 24.4744 7.73426 24.0948L1.86238 26.7156L3.82426 21.4186C2.64676 20.27 1.69551 18.9233 1.03738 17.4426C0.32676 15.8442 -0.0444902 14.0889 0.00425975 12.257C0.0980098 8.71595 1.73863 5.57221 4.31426 3.35365C6.84863 1.17055 10.2955 -0.117164 14.0524 0.00841478H14.0549ZM14.0261 1.53878L14.0124 1.53807C10.5705 1.42384 7.42738 2.59095 5.12801 4.57113C2.87051 6.51654 1.43301 9.24665 1.35176 12.2989C1.30988 13.8682 1.62988 15.3759 2.24176 16.753C2.88488 18.2004 3.85051 19.5058 5.05738 20.5913L5.45926 20.9525L4.34488 23.9607L7.75051 22.4403L8.00488 22.5637C8.82613 22.9617 9.70301 23.2789 10.6224 23.5038C11.5224 23.7237 12.458 23.8557 13.4161 23.8876C16.8593 24.0026 20.0036 22.8347 22.303 20.8546C24.5611 18.9092 25.9986 16.1798 26.0799 13.1268V13.119C26.1586 10.0689 24.8705 7.25157 22.7224 5.16142C20.5343 3.03225 17.4643 1.65655 14.0286 1.53878H14.0261Z" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_1047_829">
            <rect width="32" height="32" fill="white"/>
            </clipPath>
            </defs>
            </svg>
        `,
            listed: true,
            page_name: "تقيمات الخدمه"
        },
    },

    {
        path: "/admin/agent-percentage",
        name: "agent-percentage",
        component: AgentPercentage,
        meta: {
            icon: `
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.8043 1.33203V5.33203H18.1963V1.33203H20.863V5.33203H23.383L28.8457 9.33203L23.3843 13.332H20.8643V16.1467H29.3337V24.1467H20.863V30.6654H18.1963V24.1467H13.8043V30.6654H11.1377V24.1467H8.61766L3.15499 20.1467L8.61632 16.1467H11.1363V13.332H2.66699V5.33203H11.1377V1.33203H13.8043ZM5.33366 7.9987V10.6654H22.5123L24.3323 9.33203L22.5123 7.9987H5.33366ZM18.1963 13.332H13.8043V16.1467H18.1963V13.332ZM9.48966 18.8134L7.66832 20.1467L9.48966 21.48H26.667V18.8134H9.48966Z" fill="white"/>
</svg>

        `,
            listed: true,
            page_name: "المؤشـــرات"
        },
    },

    {
        path: "/admin/agent-percentage/admin-rates-page",
        name: "admin-rates-page",
        component: AdminReviewsPage,
        meta: {
            listed: false,
            page_name: "المؤشـــرات  تقييمات العملاء"
        },
    },

    {
        path: "/admin/agent-percentage/admin-whatsapp-msg-page",
        name: "admin-whatsapp-msg-page",
        component: AdminWhatsappMsgPage,
        meta: {
            listed: false,
            page_name: "المؤشـــرات  رسائل الواتساب "
        },
    },

    {
        path: "/admin/agent-percentage/admin-call-center-page",
        name: "admin-call-center-page",
        component: AdminCallCenterPage,
        meta: {
            listed: false,
            page_name: "المؤشـــرات (المكالمات)"
        },
    },

    {
        path: "/admin/agent-percentage/admin-recieved-page",
        name: "admin-recieved-page",
        component: AdminRecievedPage,
        meta: {
            listed: false,
            page_name: "المؤشـــرات Reviews"
        },
    },

    {
        path: "/admin/agent-percentage/admin-requests-statistics-page/:type",
        name: "admin-requests-statistics-page",
        component: AdminRequestsStatisticsPage,
        meta: {
            listed: false,
            page_name: "المؤشـــرات Requests"
        },
    },

    {
        path: "/admin/support",
        name: "admin-support",
        component: AdminSupport,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M27.9997 10.6659C28.7069 10.6659 29.3852 10.9468 29.8853 11.4469C30.3854 11.947 30.6663 12.6253 30.6663 13.3325V18.6659C30.6663 19.3731 30.3854 20.0514 29.8853 20.5515C29.3852 21.0516 28.7069 21.3326 27.9997 21.3326H26.5837C26.2586 23.9103 25.004 26.2808 23.0553 27.9992C21.1066 29.7176 18.5978 30.6658 15.9997 30.6659V27.9992C18.1214 27.9992 20.1562 27.1564 21.6565 25.6561C23.1568 24.1558 23.9997 22.1209 23.9997 19.9992V11.9992C23.9997 9.87748 23.1568 7.84265 21.6565 6.34236C20.1562 4.84207 18.1214 3.99922 15.9997 3.99922C13.8779 3.99922 11.8431 4.84207 10.3428 6.34236C8.84253 7.84265 7.99967 9.87748 7.99967 11.9992V21.3326H3.99967C3.29243 21.3326 2.61415 21.0516 2.11406 20.5515C1.61396 20.0514 1.33301 19.3731 1.33301 18.6659V13.3325C1.33301 12.6253 1.61396 11.947 2.11406 11.4469C2.61415 10.9468 3.29243 10.6659 3.99967 10.6659H5.41567C5.74105 8.08841 6.99578 5.71825 8.94444 4.00012C10.8931 2.28199 13.4017 1.33398 15.9997 1.33398C18.5976 1.33398 21.1063 2.28199 23.0549 4.00012C25.0036 5.71825 26.2583 8.08841 26.5837 10.6659H27.9997ZM10.3463 21.0459L11.7597 18.7845C13.0304 19.5806 14.5002 20.0016 15.9997 19.9992C17.4992 20.0016 18.9689 19.5806 20.2397 18.7845L21.653 21.0459C19.9587 22.1074 17.9991 22.669 15.9997 22.6659C14.0003 22.669 12.0406 22.1075 10.3463 21.0459Z" fill="white"/>
            </svg>
        `,
            listed: true,
            page_name: "طلبات الدعم الفني"
        },
    },
    {
        path: "/admin",
        name: "adminHome",
        meta: {
            icon: "",
            listed: false,
            page_name: "المستخدمين",
            breadcrumb: "",
        },
        // redirect: { name: "users" },
        redirect: { name: "agent-percentage" },
    },
    {
        path: "/admin/requests/all",
        name: " all",
        component: AdminAllRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "جميع الطلبات",
            breadcrumb: "",
        },
    },
    {
        path: "/admin/requests/general",
        name: "general",
        component: AdminGeneralRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "السلة العامة ",
            breadcrumb: "",
        },
    },
    {
        path: "/admin/requests/processing",
        name: "processing",
        component: AdminProcessingRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "سلة المبيعات ",
            breadcrumb: "",
        },
    },
    {
        path: "/admin/requests-customer-service",
        name: "processing",
        component: CustomerServiceRequests,
        meta: {
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path d="M22.667 5.33398H9.33366C7.8609 5.33398 6.66699 6.52789 6.66699 8.00065V25.334C6.66699 26.8067 7.8609 28.0007 9.33366 28.0007H22.667C24.1398 28.0007 25.3337 26.8067 25.3337 25.334V8.00065C25.3337 6.52789 24.1398 5.33398 22.667 5.33398Z" stroke="white" stroke-width="2"></path>
      <path d="M12 12H20M12 17.3333H20M12 22.6667H17.3333" stroke="white" stroke-width="2" stroke-linecap="round"></path>
    </svg>`,
            listed: true,
            group: "خدمة العملاء",
            page_name: "سلة خدمة العملاء ",
            breadcrumb: "",
        },
    },
    {
        path: "/admin/requests/recieved",
        name: " recieved",
        component: AdminRecievedRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المستلمه",
        },
    },

    {
        path: "/admin/requests/latest",
        name: "latest",
        component: AdminLateRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " الذهبية ",
        },
    },
    {
        path: "/admin/requests/followed",
        name: " followed",
        component: AdminFollowedRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المتابعة",
        },
    },

    {
        path: "/admin/requests/has-personal-request",
        name: "has_personal_request",
        component: AdminHasPersonalRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "لها طلبات شخصية",
        },
    },

    {
        path: "/admin/requests/administration",
        name: "administration_requests",
        component: AdministrationRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "طلبات الإدارة",
        },
    },

    {
        path: "/admin/requests/fundingDurationRequests",
        name: "funding_duration_average",
        component: AdminFundingDurationRequests,
        meta: {
            icon: "",
            listed: true,
            group: "التقارير",
            page_name: "متوسط مدة التمويل",
        },
    },

    {
        path: "/admin/reports/tryToRegisterAgain",
        name: "try_to_register_again",
        component: ClientRegisterRequestAgain,
        meta: {
            only_in_menu: true,
            icon: "",
            listed: true,
            group: "التقارير",
            page_name: "محاولات تسجيل العميل مره أخري ",
        },
    },

    {
        path: "/admin/requests/featured",
        name: "featured",
        component: AdminFeaturedRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المميزة",
        },
    },
    {
        path: "/admin/requests/archieved",
        name: " archieved",
        component: AdminArchievedRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المؤرشفة",
        },
    },
    {
        path: "/admin/requests/pending",
        name: "pending",
        component: AdminPendingRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المعلقة",
        },
    },
    {
        path: "/admin/requests/need-action-new",
        name: "new",
        component: AdminNeedActionNew,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "للتحويل-جديدة",
        },
    },
    {
        path: "/admin/requests/need-action-done",
        name: "done",
        component: AdminNeedActiondone,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "للتحويل-تمت معالجتها",
        },
    },
    {
        path: "/admin/requests/wating-new",
        name: "wating-new",
        component: AdminWatingNewRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "الانتظار-جديدة",
        },
    },
    {
        path: "/admin/requests/wating-done",
        name: "wating-done",
        component: AdminWatingDoneRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "الانتظار-تمت معالجتها",
        },
    },
    {
        path: "/admin/requests/freeze",
        name: "freeze",
        component: AdminFreezingRequests,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: " المجمدة",
        },
    },
    {
        path: "/admin/requests/need-to-turn-new",
        name: "needToTurnNew",
        component: AdminNeedToTurnNew,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "بحاجه للتحويل-(جوده-جديدة)",
        },
    },
    {
        path: "/admin/requests/need-to-turn-done",
        name: "needToTurnDone",
        component: AdminNeedToTurnDone,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "بحاجه للتحويل-(جودة-تمت معالجتها)",
        },
    },

    {
        path: "/admin/requests/archived-in-quality",
        name: "archivedInQuality",
        component: AdminArchivedInQuality,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "أرشيف الجودة",
        },
    },


    {
        path: "/admin/requests/duplicated",
        name: "duplicatedRequests",
        component: DuplicatedCustomers,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "سلة المكررة ",
            breadcrumb: "",
        },
    },
    // {
    //     path: "/admin/vacations/agent_vacation",
    //     name: "agent_vacation",
    //     component: AgentsVacations,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الاجازات",
    //         page_name: "طلبات الاجازه للاستشارين",
    //     },
    // },
    // {
    //     path: "/admin/vacations/finance_supervisors",
    //     name: "finance_supervisors",
    //     component: FinanceSupervisorsVacations,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الاجازات",
    //         page_name: "طلبات الاجازه لمشرفين التمويل",
    //     },
    // },
    // {
    //     path: "/admin/vacations/mortgage_managers",
    //     name: "mortgage_managers",
    //     component: MortgageManagersVacations,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الاجازات",
    //         page_name: "طلبات الاجازه لمدراء الرهن",
    //     },
    // },
    // {
    //     path: "/admin/vacations/sales_manager_vacation",
    //     name: "sales_manager_vacation",
    //     component: SalesManagerVacations,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الاجازات",
    //         page_name: "طلبات الاجازه لمدراء المبيعات",
    //     },
    // },
    
    

    {
        path: "/admin/user-profile/:id/personal-info",
        name: "personal-info",
        component: PersonalInformation,
        meta: { icon: "", listed: false, page_name: " الملف الشخصي" },
    },

    {
        path: "/admin/user-profile/:id/jop-info",
        name: "jop-info",
        component: JopInfo,
        meta: { icon: "", listed: false, page_name: "معلومات الوظيفه" },
    },

    {
        path: "/admin/user-profile/:id/attachments-profile",
        name: "attachments-profile",
        component: AttachmentsProfile,
        meta: {
            icon: ``,
            listed: false,
            page_name: " مرفقات الملف الشخصى",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/user-profile/:id/user-qualification",
        name: "user-qualification",
        component: UserQualification,
        meta: {
            icon: ``,
            listed: false,
            page_name: "المؤهلات",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/user-profile/:id/user-bail",
        name: "user-bail",
        component: UserBail,
        meta: {
            icon: ``,
            listed: false,
            page_name: " الكفالة",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/user-profile/:id/user-identity",
        name: "user-identity",
        component: UserIdentity,
        meta: {
            icon: ``,
            listed: false,
            page_name: " الهوية",
            breadcrumb: "",
        },
    },

    {
        path: "/admin/user-profile/:id/user-notes",
        name: "user-notes",
        component: UserNotes,
        meta: {
            icon: ``,
            listed: false,
            page_name: " ملاحظات",
            breadcrumb: "",
        },
    },

    // {
    //     path: "/admin/user-profile/:id/user-holidays",
    //     name: "user-holidays",
    //     component: UserHolidays,
    //     meta: {
    //         icon: ``,
    //         listed: false,
    //         page_name: " الاجازات",
    //         breadcrumb: "",
    //     },
    // },
    {
        path: "/admin/settings/mortgage_settings-classification",
        name: "mortgage_settings_classification",
        component: MortgageSettingsClassification,
        meta: {
            icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
          <g id="Analytics_2" data-name="Analytics 2" transform="translate(-1 -1)">
            <rect id="Rectangle_1796" data-name="Rectangle 1796" width="18" height="18" rx="1.5" transform="translate(1.5 1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1797" data-name="Rectangle 1797" width="2" height="12" transform="translate(9.5 4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1798" data-name="Rectangle 1798" width="2" height="6" transform="translate(14.5 10.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1799" data-name="Rectangle 1799" width="2" height="9" transform="translate(4.5 7.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
          </g>
        </svg>
        `, listed: true, group: "اعدادت التقارير", page_name: "اعدادات الزاميات تصنيفات طلبات الرهن"
        },
    },

    {
        path: "/admin/settings/mortgage_settings",
        name: "mortgage_settings",
        component: MortgageSettings,
        meta: { icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
          <g id="Analytics_2" data-name="Analytics 2" transform="translate(-1 -1)">
            <rect id="Rectangle_1796" data-name="Rectangle 1796" width="18" height="18" rx="1.5" transform="translate(1.5 1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1797" data-name="Rectangle 1797" width="2" height="12" transform="translate(9.5 4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1798" data-name="Rectangle 1798" width="2" height="6" transform="translate(14.5 10.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1799" data-name="Rectangle 1799" width="2" height="9" transform="translate(4.5 7.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
          </g>
        </svg>
        `, listed: true,group: "اعدادت التقارير", page_name:  "اعدادات طلبات الرهن"},
    },

    {
        // path: "/admin/reports/latestReport",
        path: "/admin/settings/latestReport",
        name: "latest_report",
        component: LatestReport,
        meta: { icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
          <g id="Analytics_2" data-name="Analytics 2" transform="translate(-1 -1)">
            <rect id="Rectangle_1796" data-name="Rectangle 1796" width="18" height="18" rx="1.5" transform="translate(1.5 1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1797" data-name="Rectangle 1797" width="2" height="12" transform="translate(9.5 4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1798" data-name="Rectangle 1798" width="2" height="6" transform="translate(14.5 10.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <rect id="Rectangle_1799" data-name="Rectangle 1799" width="2" height="9" transform="translate(4.5 7.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
          </g>
        </svg>
        `, listed: true,group: "الرسوم البيانية", page_name:  "تقرير الطلبات الذهبية "},
    },

    {
        path: "/admin/user-settings/users",
        name: "users",
        component: UsersSettings,
        meta: { icon: ``, listed: true, group: "إدارة المستحدمين", page_name:  "المستخدمين"},
    },

    {
        path: "/admin/target-settings/users",
        name: "users",
        component: () => import('@/views/admin/UserSettings/UsersSettings/TargetSettings.vue'),
        meta: { only_in_menu: true, icon: ``, listed: true, group: "إدارة المستحدمين", page_name: "إعدادات المؤشـــرات" },
    },

    {
        path: "/admin/settings/requests-baskets",
        name: "settings_requests_baskets",
        component: RequestSetting,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "إعدادت الطلبات وسلال السحب",
        },
    },

    {
        path: "/admin/settings/requests-sources",
        name: "settings_requests_source",
        component: RequestSourceSetting,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "إعدادت ظهور مصادر المعاملة",
        },
    },
    /*//stop using this report for now
    {
        path: "/admin/settings/requests-received-report",
        name: "settings_requests_received_report",
        component: RequestsReceivedReport,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "تقرير الطلبات المستلمة",
        },
    },
    */
    {
        path: "/admin/reports/requests-received-web-report",
        name: "settings_requests_received_web_report",
        component: RequestsReceivedWebReport,
        meta: {
            only_in_menu: true,
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "تقرير استلام الطلبات",
        },
    },

    {
        path: "/admin/reports/ticket-transfers",
        name: "admin_ticket_transfer_report",
        component: TicketTransferReport,
        meta: {
            only_in_menu: true,
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "تقرير تحويل التذاكر للادمن",
        },
    },


    {
        path: "/admin/settings/requests-received-report-details",
        name: "settings_requests_received_report_details",
        component: RequestsReceivedReportDetails,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "تفاصيل تقرير الطلبات المستلمة",
        },
    },


    {
        path: "/admin/settings/baskets",
        name: "basket_settings",
        component: BasketSetting,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "إعدادت ظهور واخفاء السلال",
        },
    },

    {
        path: "/admin/settings/questions-and-answers",
        name: "question_and_answers",
        component: QuestionAndAnswerSetting,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "إعدادت (منتدى الوساطة)",
        },
    },

    {
        path: "/admin/settings/classifications",
        name: "settings_classifications",
        component: ClassificationSettingsIndex,
        meta: {
            icon: "",
            listed: true,
            group: "اعدادت التقارير",
            page_name: "جميع تصنيفات الطلب",
        },
    },

    /*{
        path: "/admin/settings/sheet-columns-config",
        name: "sheet_columns_config",
        component: SheetColumnsConfig,
        meta: {
            icon: `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
              <line x1="9" y1="9" x2="15" y2="9"/>
              <line x1="9" y1="15" x2="15" y2="15"/>
            </svg>
            `,
            listed: true,
            group: "اعدادت التقارير",
            page_name: "إعدادات الجداول والأعمدة",
        },
    },*/

    

    {
        path: "/admin/settings/latestRequests/chart",
        name: "latestRequestsChart",
        component: LatestRequestsChart,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "رسم بياني للحرة",
        },
    },

    {
        path: "/admin/settings/cities/chart",
        name: "citiesRequestsChart",
        component: CitiesRequestsChart,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: " المدن",
        },
    },

    {
        path: "/admin/settings/request-calls",
        name: "RequestCalls",
        component: RequestCalls,
        meta: {
            icon: "",
            listed: true,
            group: "الرسوم البيانية",
            page_name: "المكالمات",
        },
    },

    {
        path: "/admin/help_desk/:id",
        name: "help_desk",
        component: SupportDetails,
        meta: { icon: "", listed: false, page_name: " طلب الدعم الفني" },
    },
    {
        path: "/admin/charts/dailyPerformance",
        name: "DailyReport",
        component: GraphsContent,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: "الأداء اليومي",
        },
    },
    {
        path: "/admin/charts/dailyPerformanceForCustomerService",
        name: "DailyReportForCustomerService",
        component: GraphsContentForCustomerService,
        meta: {
            icon: "",
            listed: true,
            group:"خدمة العملاء",
            page_name: "الأداء اليومي لخدمه العملاء",
        },
    },
    {
        path: "/admin/charts/requests-status",
        name: "RequestsStatus",
        component: RequestsStatus,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: "حالات الطلب",
        },
    },
    {
        path: "/admin/charts/rateAverage",
        name: "rateAverage",
        component: RateAverageReport,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: "تقييمات الخدمة",
        },
    },
    // {
    //     path: "/admin/charts/productivity",
    //     name: "productivity-charts",
    //     component: ProductivityContent,
    //     meta: {
    //         icon: "",
    //         listed: true,
    //         group: "الرسوم البيانية",
    //         page_name: "تقرير الإنتاجية ",
    //     },
    // },
    {
        path: "/admin/charts/productivity-v3",
        name: "productivity-charts-v3",
        component: ProductivityContentV3,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: "تقرير الإنتاجية ",
        },
    },
    {
        path: "/admin/charts/productivity-v3-cs",
        name: "productivity-charts-v3-cs",
        component: ProductivityContentV3CS,
        meta: {
            icon: "",
            listed: true,
            group: "خدمة العملاء",
            page_name: "تقرير الإنتاجية لخدمة العملاء",
        },
    },
    {
        path: "/admin/charts/productivityForCustomerService",
        name: "productivityForCustomerService",
        component: ProductivityContentForCustomerService,
        meta: {
            icon: "",
            listed: false,
            group:"خدمة العملاء",
            page_name: "تقرير الإنتاجية لخدمة العملاء",
        },
    },
    
    {
        path: "/admin/charts/mortgage-report",
        name: "mortgage-report",
        component: MortgageReportContent,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: " الرهن ",
        },
    },
    {
        path: "/admin/charts/requests-sources",
        name: "requests-sources-charts",
        component: RequestSourcesContent,
        meta: {
            icon: "",
            listed: true,
            group:"الرسوم البيانية",
            page_name: " مصادر المعاملات ",
        },
    },

    /*{
        path: "/admin/requests/dublicated",
        name: " all",
        component: DuplicatedCustomersBasket,
        meta: {
            icon: "",
            listed: true,
            group: " الطلبات",
            page_name: "الطلبات المكررة",
            breadcrumb: "",
        },
    },*/
/*
    {
        path: "/admin/alerts",
        name: "alerts",
        component: AlertsIndex,
        meta: {
            icon: ``,
            listed: true,
            group: "اعدادات النظام",
            page_name:  "التنبيهات"
        },
    },*/
    {
        path: "/admin/check-exists-customers-by-excel",
        name: "check-exists-customers-by-excel",
        component: CheckExistsCustomersByExcel,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "التحقق من العملاء",
        },
    },
    {
        path: "/admin/funding-form-submissions",
        name: "FundingFormSubmissions",
        component: FundingFormSubmissions,
        meta: {
            only_in_menu: true,
            icon: ``,
            listed: true,
            group: " الطلبات",
            page_name: "سلة عملاء بدون تفعيل - اطلب تمويل",
        },
    },

    {
        path: "/admin/requestDescription",
        name: "requestDescription",
        component: RequestDescription,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "اعدادت موقع الوساطه",
        },
    },

    {
        path: "/admin/alerts",
        name: "alerts",
        component: UsersAlerts,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "التنبيهات",
        },
    },

    {
        path: "/admin/alert/:id/seen",
        name: "alert-seen",
        component: AlertShow,
        meta: { icon: "", listed: false, page_name: "عرض الذين شاهدو التنبيه" },
    },
    {
        path: "/admin/announcements",
        name: "announcements",
        component: UsersAnnouncements,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "التعميمات",
        },
    },
    {
        path: "/admin/call-centers",
        name: "callCenters",
        component: CustomersSettingIndex,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "الكول سنتر ",
        },
    },
    {
        path: "/admin/setings-general",
        name: "setings-general",
        component: GeneralSettingIndex,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "اعدادات عامة  ",
        },
    },

    {
        path: "/admin/customer-service-settings",
        name: "customer-service-settings",
        component: CustomerServiceSettingIndex,
        meta: {
            icon: ``,
            listed: true,
            group:"اعدادات النظام",
            page_name: "اعدادات خدمة العملاء",
        },
    },

    {
        path: "/admin/drop-down-settings",
        name: "drop-down-settings",
        component: DropdownSettingsIndex,
        meta: {
            icon: ``,
            listed: true,
            group: "اعدادات النظام",
            page_name: "اعدادات القوائم المنسدلة",
        },
    },

    {
        path: "/admin/settings/test-mobile-numbers",
        name: "test-mobile-numbers",
        component: () => import("@/views/admin/Settings/TestMobileNumbers.vue"),
        meta: {
            icon: ``,
            listed: true,
            group: "اعدادات النظام",
            page_name: "اضافة ارقام التيست",
        },
    },

   
    {
        path: "/admin/announcement/:id/seen",
        name: "announcement-seen",
        component: AnnouncementShow,
        meta: { icon: "", listed: false, page_name: "عرض الذين شاهدو التعميم" },
    },
    
    {
        path: "/admin/google-sheet-import",
        name: "google-sheet-import",
        component: GoogleSheetImport,
        meta: {
            icon: ``,
            listed: true,
            group: "اعدادات النظام",
            page_name: "استيراد Google Sheets",
        },
    },

    {
        path: "/admin/developer/drive-calls",
        name: "developer-drive-calls",
        component: () => import("@/views/admin/Developer/DriveCalls.vue"),
        meta: {
            icon: ``,
            listed: true,
            group: "فريق التطوير",
            page_name: "مكالمات Google Drive",
            developer_only: true,
        },
    },

    {
        path: "/admin/developer/google-sheet-export",
        name: "google-sheet-export",
        component: () => import("@/views/admin/Developer/GoogleSheetExport.vue"),
        meta: {
            icon: ``,
            listed: true,
            group: "فريق التطوير",
            page_name: "تصدير Google Sheet",
        },
    },

    {
        path: "/admin/developer/google-sheet-request-check",
        name: "google-sheet-request-check",
        component: () => import("@/views/admin/Developer/GoogleSheetRequestCheck.vue"),
        meta: {
            icon: ``,
            listed: true,
            group: "فريق التطوير",
            page_name: "فحص طلب في Google Sheet",
        },
    },
    
        /*
        //you can set order from src/routes/userMenu.js — same fields in every role router
        meta: {
            listed: true, // عرض في القائمة
            icon: `<svg>...</svg>`, // أيقونة الصفحة
            page_name: "أول صفحة", // عنوان الصفحة
            groupIcon: `<svg>...</svg>`, // أيقونة المجموعة
            group: "مجموعة جديدة", // عنوان المجموعة
            menuSort: 3, // ترتيب الصفحة في المجموعة او ترتيب اللينك في القائمة
            groupSort: 2, // ترتيب المجموعة
            developer_only: true, // عرض فقط للمطورين
            only_in_menu: true, // عرض فقط في القائمة
            breadcrumb: "الصفحة الرئيسية", // العنوان المروض في العنوان المتصفح
            is_for_customer_service: 1, // عرض فقط لخدمة العملاء
            mewTab: true, // عرض فقط في التبويب الجديد
        }*/
    // ==============================================
]